import { Grid, TextField, Button } from "@mui/material";
import { DbUser } from "../../../../interfaces";
import { School } from "@backend-types";
import { UserManagementModal } from "../UserManagementModal";
import { makeStyles } from "@mui/styles";
import { generateGtmEvent } from "../../../../Helpers";

const useStyles = makeStyles({
  textField: {
    "& .MuiFormLabel-root": {
      fontWeight: 500,
      fontSize: 14,
      color: "#747474",
      textTransform: "uppercase",
      letterSpacing: 0.7,
    },
    "& .MuiInputBase-root": {
      color: "#484848",
      borderBottom: "none !important",
      fontSize: 16,
      fontWeight: 400,
      paddingBottom: "1rem",
      "& .Mui-disabled": {
        "-webkit-text-fill-color": "unset",
      },
    },
  },
  borderBottom: {
    width: "100%",
    borderBottom: "1px solid #E8E8E8",
  },
});

export type ViewSchoolProps = {
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  currentUser: DbUser;
  school?: School;
};

export function ViewSchool(props: ViewSchoolProps) {
  const classes = useStyles();

  const fieldProps = {
    fullWidth: true,
    disabled: true,
    className: classes.textField,
    InputProps: {
      disableUnderline: true,
    },
  };

  const name = props.school?.name ?? " ";
  const district = props.school?.district ?? " ";
  const HandleDataLayer = (
    event: string,
    action: string,
    name: string,
    type: string,
    region: string,
    section: string,
    text: string
  ) => {
    generateGtmEvent({ event, action, name, type, region, section, text });
  };
  return (
    <UserManagementModal
      hideSubmitButton={true}
      title={name}
      titleElem={
        <>
          {name}
          <Button
            variant="outlined"
            size={"small"}
            disableElevation
            sx={{
              marginLeft: "1em",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "primary.light",
              },
            }}
            onClick={() => {
              HandleDataLayer(
                "link",
                "click",
                "onclick",
                "internal link",
                "modal",
                name,
                "edit"
              );
              props.onEdit();
            }}>
            Edit
          </Button>
        </>
      }
      open={props.open}
      onClose={props.onClose}>
      <Grid container spacing={6}>
        <Grid item xs={6} order={1}>
          <TextField label="School" value={name} variant="standard" {...fieldProps} />
        </Grid>
        <Grid item xs={6} order={2}>
          <TextField
            label="District"
            value={district}
            variant="standard"
            {...fieldProps}
          />
        </Grid>
      </Grid>
    </UserManagementModal>
  );
}
